import {NgModule} from '@angular/core';
import {RemoveHostDirective} from './removeHost.directive';
import {SuppressScrollEventDirective} from './supressScroll.directive';
import {OnlyNumbersDirective} from './onlyNumbers.directive';
import {ScrollStateDirective} from './scrollState.directive';
import { ChatHeightDirective } from "app/core/directives/chatHeight.directive";

@NgModule({
  imports: [],
  declarations: [
    RemoveHostDirective,
    SuppressScrollEventDirective,
    OnlyNumbersDirective,
    ScrollStateDirective,
    ChatHeightDirective
  ],
  exports: [
    RemoveHostDirective,
    SuppressScrollEventDirective,
    OnlyNumbersDirective,
    ScrollStateDirective,
    ChatHeightDirective
  ]
})
export class DirectivesModule {
}
